let lastScrollPosition = 0;
window.addEventListener('scroll', function() {
    let body = document.body;
    let scrollPosition = window.scrollY || document.documentElement.scrollTop;
    var button = header.querySelector('.btn');
    var burger = header.querySelector('.hamburger-lines');

    if (scrollPosition > 200) {
        body.classList.add('scrolled');
        // button.classList.remove('solid-dark');
        // button.classList.add('solid-light');
        burger.classList.remove('light');
        burger.classList.add('dark');
        if (scrollPosition > 500) {
            body.classList.add('scrolled-down');
        } else {
            body.classList.remove('scrolled-down');
        }
    } else {
        body.classList.remove('scrolled', 'scrolled-up', 'scrolled-down');
        // button.classList.remove('solid-light');
        // button.classList.add('solid-dark');

        burger.classList.remove('dark');
        burger.classList.add('light');
    }
    lastScrollPosition = scrollPosition;
});

//# sourceMappingURL=scroll-menu-light.js.map
